import md5 from "md5"

export const hashGenerator = (value, auth) => {
  const mask = `$%Klan10Tin0|${value}|VaiCorinthians!${auth}`
  return md5(mask)
}
